import { render, staticRenderFns } from "./ProductStatementAnswers.vue?vue&type=template&id=11dda266&"
import script from "./ProductStatementAnswers.vue?vue&type=script&lang=js&"
export * from "./ProductStatementAnswers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports